// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.juniorContainer > img {
  width: 100%;
  object-fit: cover;
  height: fit-content;
}
.juniorContainer > div {
  width: 80%;
  margin: auto;
  padding: 60px 0px;
}
.juniorContainer > div > p {
  color: #000;
  margin-bottom: 20px;
  font-family: lightThicker !important ;
  font-size: clamp(16px, 4vw, 20px);
  font-weight: 400;
}
.bottom {
  width: 100% !important;
  padding: 50px 0px !important;
  background-color: #ba1e24;
  text-align: center;
}
.bottom > h1 {
  color: #fff;
  font-size: 54px;
  font-weight: 700;
}
.bottom > p {
  color: #fff !important;
  text-align: center;
  font-size: 20px;
  margin-bottom: 0px !important;
  font-family: lightThicker !important;
}
.bottom > button {
  margin-top: 50px;
  color: #fff;
  font-size: clamp(18px, 4vw, 24px) !important;
  font-weight: 600;
  padding: 10px 25px;
  background: linear-gradient(0deg, #000 0%, #000 100%), #fff;
  border: none;
  cursor: pointer;
}
.findRace {
  width: 100% !important;
  height: 100%;
  background: linear-gradient(
    to bottom,
    #ba1e24 50%,
    #ba1e24 0%,
    #262626 50%,
    #262626 100%
  );
}
.findRace > div {
  width: 80%;
  margin: auto;
}
.findRace > div > h1 {
  color: #fff;
  font-size: clamp(40px, 4vw, 80px) !important;
  font-weight: 600;
  /* margin-bottom: 20px; */
}
.findRace > div > div {
  display: flex !important;
}
.findRace > div > div > div {
  background-color: #1e1e1e;
  padding: 12px;
  margin: 10px;
  box-shadow: 0px 0px 20px -6px rgba(0, 0, 0, 0.15);
}

.findRace > div > div > div > image {
  height: 200px;
}
.findRace > div > div > div > h1 {
  margin: 10px 0px;
  color: #fff;
  font-size: 20px;
  font-weight: 600;
}
.findRace > div > div > div > p {
  font-size: 16px;
  font-weight: 400;
  color: #fff;
  font-family: lightThicker !important;
}
.findRace > div > div > div > p > div {
  display: none;
}
.findRace > div > div > div:hover .findRace > div > div > div > p {
  display: none;
}
.findRace > div > div > div:hover .findRace > div > div > div > div {
  display: flex;
}
.findRace > div > div > div > button:first-child {
  background-color: #161616;
  color: #fff;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
@media screen and (max-width: 600px) {
  .juniorContainer > div {
    width: 90%;
    padding: 20px 0px;
  }
  .findRace {
    height: auto;
  }
  .findRace > div > div {
    display: block !important;
  }
  .bottom {
    padding: 20px 0px !important;
  }
  .bottom > button {
    margin-top: 20px;
    padding: 4px 15px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/categories/junior.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,qCAAqC;EACrC,iCAAiC;EACjC,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,oCAAoC;AACtC;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,4CAA4C;EAC5C,gBAAgB;EAChB,kBAAkB;EAClB,2DAA2D;EAC3D,YAAY;EACZ,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ;;;;;;GAMC;AACH;AACA;EACE,UAAU;EACV,YAAY;AACd;AACA;EACE,WAAW;EACX,4CAA4C;EAC5C,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,YAAY;EACZ,iDAAiD;AACnD;;AAEA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,oCAAoC;AACtC;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE;IACE,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF","sourcesContent":[".juniorContainer > img {\n  width: 100%;\n  object-fit: cover;\n  height: fit-content;\n}\n.juniorContainer > div {\n  width: 80%;\n  margin: auto;\n  padding: 60px 0px;\n}\n.juniorContainer > div > p {\n  color: #000;\n  margin-bottom: 20px;\n  font-family: lightThicker !important ;\n  font-size: clamp(16px, 4vw, 20px);\n  font-weight: 400;\n}\n.bottom {\n  width: 100% !important;\n  padding: 50px 0px !important;\n  background-color: #ba1e24;\n  text-align: center;\n}\n.bottom > h1 {\n  color: #fff;\n  font-size: 54px;\n  font-weight: 700;\n}\n.bottom > p {\n  color: #fff !important;\n  text-align: center;\n  font-size: 20px;\n  margin-bottom: 0px !important;\n  font-family: lightThicker !important;\n}\n.bottom > button {\n  margin-top: 50px;\n  color: #fff;\n  font-size: clamp(18px, 4vw, 24px) !important;\n  font-weight: 600;\n  padding: 10px 25px;\n  background: linear-gradient(0deg, #000 0%, #000 100%), #fff;\n  border: none;\n  cursor: pointer;\n}\n.findRace {\n  width: 100% !important;\n  height: 100%;\n  background: linear-gradient(\n    to bottom,\n    #ba1e24 50%,\n    #ba1e24 0%,\n    #262626 50%,\n    #262626 100%\n  );\n}\n.findRace > div {\n  width: 80%;\n  margin: auto;\n}\n.findRace > div > h1 {\n  color: #fff;\n  font-size: clamp(40px, 4vw, 80px) !important;\n  font-weight: 600;\n  /* margin-bottom: 20px; */\n}\n.findRace > div > div {\n  display: flex !important;\n}\n.findRace > div > div > div {\n  background-color: #1e1e1e;\n  padding: 12px;\n  margin: 10px;\n  box-shadow: 0px 0px 20px -6px rgba(0, 0, 0, 0.15);\n}\n\n.findRace > div > div > div > image {\n  height: 200px;\n}\n.findRace > div > div > div > h1 {\n  margin: 10px 0px;\n  color: #fff;\n  font-size: 20px;\n  font-weight: 600;\n}\n.findRace > div > div > div > p {\n  font-size: 16px;\n  font-weight: 400;\n  color: #fff;\n  font-family: lightThicker !important;\n}\n.findRace > div > div > div > p > div {\n  display: none;\n}\n.findRace > div > div > div:hover .findRace > div > div > div > p {\n  display: none;\n}\n.findRace > div > div > div:hover .findRace > div > div > div > div {\n  display: flex;\n}\n.findRace > div > div > div > button:first-child {\n  background-color: #161616;\n  color: #fff;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n@media screen and (max-width: 600px) {\n  .juniorContainer > div {\n    width: 90%;\n    padding: 20px 0px;\n  }\n  .findRace {\n    height: auto;\n  }\n  .findRace > div > div {\n    display: block !important;\n  }\n  .bottom {\n    padding: 20px 0px !important;\n  }\n  .bottom > button {\n    margin-top: 20px;\n    padding: 4px 15px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
